<div class="whats-new__card" [class.is-entering]="!reducedMotion">
  <div class="whats-new__bars" aria-hidden="true">
    @for (item of items; track item.id) {
      <span><i #fill></i></span>
    }
  </div>

  <div class="whats-new__tools">
    @if (!reducedMotion) {
      <button
        type="button"
        class="whats-new__round whats-new__sound"
        [attr.aria-label]="muted() ? 'Ligar o som' : 'Desligar o som'"
        (click)="toggleSound()"
      >
        @if (muted()) {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M11 5 6 9H2v6h4l5 4V5z" />
            <path d="m23 9-6 6" />
            <path d="m17 9 6 6" />
          </svg>
        } @else {
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M11 5 6 9H2v6h4l5 4V5z" />
            <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
          </svg>
        }
      </button>
    }

    @if (!locked()) {
      <button type="button" class="whats-new__round whats-new__x" aria-label="Fechar" (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
    }
  </div>

  <div class="whats-new__media" #media [class.is-held]="held()">
    <div class="whats-new__track" #track>
      @for (item of items; track item.id) {
        <!-- O <video> entra pelo componente (o mesmo elemento que já vinha baixando desde a abertura do app). -->
        <div class="whats-new__slide" #slide>
          @if (reducedMotion) {
            <img [src]="item.posterUrl" alt="" />
          }
        </div>
      }
    </div>
    <span class="whats-new__paused" aria-hidden="true">Pausado</span>
  </div>

  <div class="whats-new__body" #body [class.is-fading]="captionFading()">
    <!-- Uma célula de grid: os medidores (invisíveis, um por novidade) deixam a legenda sempre com a
         altura da maior, então o cartão não muda de tamanho ao trocar de novidade. -->
    <div class="whats-new__copy">
      @for (item of items; track item.id) {
        <div class="whats-new__sizer" aria-hidden="true">
          <h3 class="whats-new__title">{{ item.title }}</h3>
          <p class="whats-new__text">{{ item.text }}</p>
          @if (item.action.type === 'support') {
            <p class="whats-new__support">A ativação é feita pelo suporte da Sisand.</p>
          }
        </div>
      }
      <div class="whats-new__live">
        <h3 class="whats-new__title" [id]="titleId" ngbAutofocus tabindex="-1">{{ caption.title }}</h3>
        <p class="whats-new__text">{{ caption.text }}</p>
        @if (caption.action.type === 'support') {
          <p class="whats-new__support">A ativação é feita pelo suporte da Sisand.</p>
        }
      </div>
    </div>

    <div class="whats-new__acts">
      @if (primaryLabel) {
        <button type="button" class="btn btn-primary whats-new__primary" (click)="runAction()">{{ primaryLabel }}</button>
      }
      <button
        type="button"
        class="btn whats-new__close"
        [class.btn-primary]="!primaryLabel"
        [disabled]="locked()"
        (click)="close()"
      >
        Fechar@if (locked()) { ({{ remaining() }})}
      </button>
    </div>

    <!-- Medidores da linha de botões (fora do fluxo, sem quebra): o cartão não fica mais estreito que
         a mais larga, contando "Fechar (5)", então nenhum rótulo quebra em duas linhas. -->
    @for (item of items; track item.id) {
      <div class="whats-new__acts whats-new__acts--sizer" aria-hidden="true">
        @if (labelOf(item); as label) {
          <span class="btn btn-primary">{{ label }}</span>
        }
        <span class="btn">Fechar ({{ lockSeconds }})</span>
      </div>
    }
  </div>
</div>

@if (index() > 0) {
  <button type="button" class="whats-new__arrow whats-new__arrow--prev" aria-label="Novidade anterior" (click)="go(index() - 1)">
    <i class="ti ti-chevron-left" aria-hidden="true"></i>
  </button>
}
@if (index() < last) {
  <button type="button" class="whats-new__arrow whats-new__arrow--next" aria-label="Próxima novidade" (click)="go(index() + 1)">
    <i class="ti ti-chevron-right" aria-hidden="true"></i>
  </button>
}
